import { useMemo, useState } from 'react'
import { useFirestoreQuery } from '../firebase/useFirestore'

// De open gevallen van een koppelstap (Status 'open') voor een koppelkaart op
// het dashboard: AddressMatches ('Adressen om te koppelen') of PersonaMatches
// ('Deelnemers om te koppelen').
//
// Nodig omdat de lijst drie toestanden moet onderscheiden die een kale
// useFirestore* niet geeft: laden (''), leeg ([]) en een geweigerde lees-actie.
// Die laatste ziet er anders uit als 'niets te doen', terwijl er juist van
// alles wacht. Eén hook voor beide kaarten, zodat die drie toestanden en de
// volgorde nergens uiteenlopen.
// AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md
// AI-CONTEXT: See docs/features/deelnemer-koppeling-algemene-link.md

const millis = (ts) => (ts && typeof ts.toMillis === 'function' ? ts.toMillis() : Number.POSITIVE_INFINITY)

/**
 * Nieuwste eerst; een nog niet bevestigde servertijd (null) bovenaan, gelijk op ID.
 * @param {{Timestamp?: any, ID: string}} a
 * @param {{Timestamp?: any, ID: string}} b
 */
const newestFirst = (a, b) => (millis(b.Timestamp) - millis(a.Timestamp)) || String(a.ID).localeCompare(String(b.ID))

/**
 * @param {'AddressMatches'|'PersonaMatches'} collection
 * @returns {{matches: Array<object>, loaded: boolean, error: Error|null}}
 */
const useOpenMatches = (collection) => {
    const [error, setError] = useState(/** @type {Error|null} */ (null))
    const docs = useFirestoreQuery(collection, {
        where: [['Status', '==', 'open']],
        initial: '',
        onError: setError,
    })

    const matches = useMemo(
        () => (Array.isArray(docs) ? [...docs].sort(newestFirst) : []),
        [docs]
    )

    return { matches, loaded: docs !== '' || Boolean(error), error }
}

export default useOpenMatches
